import { observable, computed, runInAction } from 'mobx';
import { get } from '../utils';
import { toast } from '../components';

/**
 * 1、商品详情页
 */
class RankDetail {
    static PAGE_SIZE = 10;
    private route: string;
    private params: any;
    private header: Object = {};

    @observable
    public firstFetched: boolean = false;
    @observable
    public isEmpty: boolean = false;
    @observable
    public lists: any;
    public list: any = [];
    @observable
    public page: any = 1;
    @observable
    public isLoadOk: any = '';

    constructor(params: any, header?: Object) {
        this.route = params.url;
        this.params = params;
        this.header = header ? header : {};
    }

    updateParams(key, val) {
        this.params[key] = val;
    }

    @observable
    private isLastPage: boolean = true;

    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    async fetch(num?, callback?) {
        var obj = Object.assign(this.params);
        get(this.route, obj, {}, this.header).then((d) => {
            this.firstFetched = true;
            let data;
            data = d.data;
            if (d.errCode == '11002') {
                toast(d.errDesc);
                setTimeout(() => {
                    location.hash = '/';
                }, 2000);
            } else if (d.errCode == '600' && num == 'floor') {
                return;
            } else {
                if (num == 1) { // 详情去下单
                    data = d.data;
                    data.productInfo.num = 1;
                    runInAction(() => {
                        this.list[0] = data.productInfo;
                    });
                    callback(data.productInfo);
                } else if (num == 2) { // 再次购买去下单
                    runInAction(() => {
                        this.lists = data;
                        if (data.orderItems) {
                            this.list = data.orderItems;
                            callback(data, data.orderItems);
                        }
                    });
                } else if (num == 'special') {
                    runInAction(() => {
                        this.lists = data;
                        callback && callback(d);
                    });
                } else {
                    if (this.route == 'regions/v1') {
                        runInAction(() => {
                            this.lists = data;
                            callback && callback(data);
                        });
                    } else {
                        runInAction(() => {
                            this.lists = data;
                            callback && callback(this.lists);
                        });
                    }
                }
            }
        });
    }
}

export default RankDetail;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/RankDetail.ts